import { twMerge } from 'tailwind-merge';
import Button, { type ButtonProps } from './Button';

interface CountBadgeProps {
  count: number;
  title?: string;
  className?: string;
}

/** Compact navy count pill. Use next to a label or inside CountButton. */
export function CountBadge({ count, title, className }: CountBadgeProps) {
  return (
    <span
      title={title}
      className={twMerge(
        'inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-secondary-blue px-1 font-mono text-[10px] font-semibold leading-none subpixel-antialiased tabular-nums text-white',
        className
      )}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}

type CountButtonProps = Omit<ButtonProps, 'children' | 'text'> & {
  text: string;
  count?: number;
  countTitle?: string;
};

/** Outline/primary button with an optional CountBadge aligned to the label. */
export function CountButton({ text, count = 0, countTitle, ...buttonProps }: CountButtonProps) {
  return (
    <Button {...buttonProps}>
      <span className="inline-flex items-center gap-2">
        {text}
        {count > 0 ? <CountBadge count={count} title={countTitle} /> : null}
      </span>
    </Button>
  );
}
